<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="全部类型" class="fn-left">
            <Select key="5" :selected.sync="listQuery.type" :data="typeStatus" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="全部状态" class="fn-left">
            <Select key="5" :selected.sync="listQuery.status" :data="opinionStatus" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="公示状态" class="fn-left">
            <Select key="5" :selected.sync="listQuery.is_open" :data="openTypes" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnGetWorkOrderList()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="时间" prop="create_time" />
        <!-- <el-table-column label="编号 " prop="work_id" /> -->
        <!-- <el-table-column label="部门/姓名" prop="dept_name"  >
          <template slot-scope="{row}">
            {{row.department_name}}
            <p>{{row.name}}</p>
          </template>
        </el-table-column> -->
        <el-table-column label="部门 " prop="department_name">
          <template slot-scope="{row}">
            {{ row.higher_level_department }}-{{ row.department_name }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="类型" prop="type_name" />
        <el-table-column label="反馈内容" prop="content" align="left" width="505px" />
        <el-table-column label="图片" prop="award_type_name">
          <template slot-scope="{row}">
            <el-image v-if="row.img" style="width: 40px; height: 40px" :src="row.img" :preview-src-list="[row.img]" fit="fit" />
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status_name" />
        <el-table-column label="是否匿名" prop="award_type_name">
          <template slot-scope="{row}">
            {{ row.is_anonymity == "1" ? "匿名" : "非匿名" }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="时间" prop="create_time" /> -->
        <el-table-column label="是否公示" prop="award_type_name">
          <template slot-scope="{row}">
            <el-switch v-model="row.is_open" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="change(row.work_id,row.is_open)" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnPopDetail(row)">详情</el-button>
            <el-button v-if="row.status < 10" type="text" @click="fnEndWork(row.work_id)">结单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetWorkOrderList" />
    </div>

    <el-dialog title="评论" :visible.sync="bCreateReply" width="70%">
      <el-form :model="replyForm" class="fn-clear">
        <el-form-item label="">
          <p v-for="(item,index) in currentReply.reply_list" :key="'reply_' + index">{{ item.reply_type == "1" ? "总裁办" : "员工" }}在{{ item.create_time }}评论: {{ item.content }}</p>
        </el-form-item>
        <el-form-item v-if="currentReply.status<10" label="添加评论">
          <el-input v-model="replyForm.content" style="width: 400px;" type="textarea" />
        </el-form-item>
        <el-form-item v-if="currentReply.status<10" label="">
          <UploadImg :photo="replyForm.img" @updateImg="updateImg" />
        </el-form-item>
      </el-form>
      <div v-if="currentReply.status<10" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitCreate()">提交</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import UploadImg from '@/components/toolbar/UploadImg.vue'

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

const defaultCreateExerciseForm = {
  exercise_title: '',
  exercise_type: '',
  exercise_schedule: [],
  award_type: ''
}

export default {
  name: 'StockExerciseList',
  components: {
    Select,
    UploadImg
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      total: 0,
      bCreateReply: false,
      exerciseLists: [],
      createExerciseForm: Object.assign({}, defaultCreateExerciseForm),
      listQuery: {
        p: 1,
        limit: 20,
        status: '0',
        type: 1,
        is_open: ''
      },
      replyForm: {
        img: '',
        content: '',
        workId: ''
      },
      openTypes: [{
        id: '0',
        name: '否'
      }, {
        id: '1',
        name: '是'
      }],
      currentReply: '',
      typeStatus: commondata.OPINION_TYPES,
      opinionStatus: commondata.OPINION_STATUS
    }
  },
  created() {
    this.fnGetWorkOrderList()
  },
  methods: {
    fnGetWorkOrderList: function() {
      this.bCreateReply = false
      this.$http.getWorkOrderList(this.listQuery).then(res => {
        this.lists = res.data.list
        this.total = parseInt(res.data.count)
      })
    },
    fnSubmitCreate() {
      if (!this.replyForm.content) {
        this.$message.error('请填写回复内容')
        return
      }
      this.$http.replyWorkOrder(this.replyForm).then(res => {
        if (res.code == 200) {
          this.$message({ message: '回复成功', type: 'success' })
          this.fnGetWorkOrderList()
        }
      })
    },
    updateImg(photo) {
      this.replyForm.img = photo
    },
    change: function(workId, isOpen) {
      this.$http.changeWorkOrderOpen({ workId, isOpen }).then(res => {
        if (res.code == 200) {
          this.$message({ message: '设置成功', type: 'success' })
        }
      })
    },
    fnEndWork: function(workId) {
      this.$confirm('是否确认操作？', '结单确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.workOrderEnd({ workId }).then(res => {
          if (res.code == 200) {
            this.$message({ message: '结课成功', type: 'success' })
            this.fnGetWorkOrderList()
          }
        })
      })
    },
    fnPopDetail: function(data) {
      this.currentReply = data
      this.replyForm.workId = data.work_id
      this.bCreateReply = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.is-left{text-align: left!important}
</style>
